export default "__VITE_ASSET__DBlEdz8G__"